<div class="dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
  <h6 mat-dialog-title>
    {{ data.sysText.editScheduleInfo_header | titlecase }}
  </h6>
  @if (isMobile$ | async) {
    <span class="spacer"></span>
    <button
      type="button"
      class="button-reset"
      (click)="cancel()"
      [attr.aria-label]="data.sysText.cancel"
      [disabled]="isSubmitting$ | async">
      <mat-icon class="button-icon">close</mat-icon>
    </button>
  }
</div>
<mat-dialog-content>
  <form [formGroup]="form" class="dialog-content-form">
    <app-input-field
      [control]="this.form.controls.scheduleName"
      [icon]="'description'"
      [label]="data.sysText.workScheduleName">
    </app-input-field>
    <app-select-field
      [control]="form.controls.ownerEmployerId"
      [label]="data.sysText.owner"
      [options]="data.options.employers"
      [icon]="'business'"
      [shouldCapitalize]="false">
    </app-select-field>
    <app-multi-select-field
      [control]="form.controls.nonWorkdays"
      [label]="data.sysText.nonWorkdays"
      [options]="data.options.nonWorkdays"
      [icon]="'event'"
      [shouldCapitalize]="false">
    </app-multi-select-field>
    <app-select-field
      [control]="form.controls.startOfWorkWeek"
      [label]="data.sysText.startOfWorkWeek"
      [options]="dayOfWeekOptions"
      [showBlankOption]="true"
      [icon]="'event'"
      [info]="data.sysText.startOfWorkWeek_info"
      [shouldCapitalize]="false">
    </app-select-field>
    <app-slide-toggle
      [control]="this.form.controls.allowUse"
      [label]="data.sysText.allowUse">
    </app-slide-toggle>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  @let isSubmitting = isSubmitting$ | async;
  @if (!(isMobile$ | async)) {
    <button
      mat-stroked-button
      class="button"
      color="accent"
      [disabled]="isSubmitting"
      (click)="cancel()">
      {{ data.sysText.cancel }}
    </button>
  }
  <!-- save keeps focus while saving: showProgress lays the spinner over its label, disabledInteractive keeps it focusable, and the guard blocks clicks -->
  <button
    mat-stroked-button
    class="button"
    color="accent"
    [disabled]="isSubmitting"
    disabledInteractive
    [showProgress]="isSubmitting"
    [attr.aria-label]="isSubmitting ? data.sysText.submitting_ariaLabel : null"
    (click)="!isSubmitting && save()">
    {{ data.sysText.save }}
    <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
  </button>
</mat-dialog-actions>
